import * as React from "react"
import compose from "recompose/compose"
import defaultProps from "recompose/defaultProps"
import getContext from "recompose/getContext"
import withContext from "recompose/withContext"
import PropTypes from "prop-types"

const KpiScopeProvider = compose(
  defaultProps({ scope: "currentUser" }),
  withContext(
    { scope: PropTypes.oneOf(["company", "currentUser"]) },
    ({ scope }) => ({
      scope,
    }),
  ),
)(props => React.Children.only(props.children))

export const withKpiScope = getContext({
  scope: PropTypes.oneOf(["company", "currentUser"]),
})

export default KpiScopeProvider
